import { render, staticRenderFns } from "./RegistrationTable.vue?vue&type=template&id=9e6caa0a&"
import script from "./RegistrationTable.vue?vue&type=script&lang=js&"
export * from "./RegistrationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports